import { render } from "./ProdutosEdit.vue?vue&type=template&id=21a95d36&scoped=true"
import script from "./ProdutosEdit.vue?vue&type=script&lang=js"
export * from "./ProdutosEdit.vue?vue&type=script&lang=js"

import "./ProdutosEdit.vue?vue&type=style&index=0&id=21a95d36&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src130918171/src/app-heineken/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21a95d36"]])

export default __exports__